import { formatIndicatorParameter, validateIndicatorInput } from './indicatorContract.js';
export const generateIndicatorKey = (indicator) => {
    validateIndicatorInput(indicator);
    let baseString = indicator.type.toLowerCase();
    // Helper function to append properties
    const appendProperty = (propValue) => {
        if (propValue !== undefined && propValue !== null)
            baseString += `-${typeof propValue === 'number' ? formatIndicatorParameter(propValue) : propValue}`;
    };
    switch (indicator.type) {
        case 'sma':
            appendProperty(indicator.period);
            break;
        case 'ema':
            appendProperty(indicator.period);
            break;
        case 'donchian':
            appendProperty(indicator.period);
            break;
        case 'macd':
            appendProperty(indicator.fastPeriod);
            appendProperty(indicator.slowPeriod);
            appendProperty(indicator.signalPeriod);
            break;
        case 'stochastic':
            appendProperty(indicator.kPeriod);
            appendProperty(indicator.dPeriod);
            appendProperty(indicator.lookback);
            break;
        case 'vwap':
            break;
        case 'vwma':
            appendProperty(indicator.period);
            break;
        case 'rsi':
            appendProperty(indicator.period);
            break;
        case 'atr':
            appendProperty(indicator.period);
            break;
        case 'lwti':
            appendProperty(indicator.period);
            break;
        case 'vma':
            appendProperty(indicator.period);
            break;
        case 'stochasticrsi':
            appendProperty(indicator.rsiPeriod);
            appendProperty(indicator.stochasticPeriod);
            appendProperty(indicator.kPeriod);
            appendProperty(indicator.dPeriod);
            break;
        case 'adx':
            appendProperty(indicator.period);
            break;
        case 'bollinger':
            appendProperty(indicator.period);
            appendProperty(indicator.multiplier);
            break;
        case 'ichimoku':
            appendProperty(indicator.tenkanPeriod);
            appendProperty(indicator.kijunPeriod);
            appendProperty(indicator.senkouBPeriod);
            appendProperty(indicator.shift);
            break;
        case 'keltner':
            appendProperty(indicator.emaPeriod);
            appendProperty(indicator.atrPeriod);
            appendProperty(indicator.multiplier);
            break;
        default:
            indicator;
            throw new Error(`Unknown indicator type: ${JSON.stringify(indicator)}`);
    }
    return baseString;
};
//# sourceMappingURL=generateIndicatorKey.js.map